import {compressAccurately} from "image-conversion";

export const compressIdCard = (file) => compressAccurately(file, {
    size: 550, // 限制为550KB
    type: "image/jpeg",
    // width: 300,
})

export const compressA4Document = (file) => compressAccurately(file, {
    size: 250, // 限制为550KB
    type: "image/jpeg",
    width: 300,
})
